<template>
  <div class="page page-recommendation">
    <div
      class="page-title"
      v-if="item"
      @click="recommendationId = item.parent">
      {{item.title}}

      <i class="fas fa-chevron-up"></i>
    </div>

    <RecommendationItem
      v-if="item && item.parent !== null"
      :recommendation="item"
      v-on:select-recommendation="selectRecommendation" />
    <RecommendationList
      v-else
      :recommendations="list"
      :showButton="recommendationId === null"
      v-on:select-recommendation="selectRecommendation"/>
  </div>
</template>

<script>
  import RecommendationList from './recommendation/List';
  import RecommendationItem from './recommendation/Item';

  export default {
    name: 'Recommendation',

    components: {RecommendationList, RecommendationItem},

    data() {
      return {
        recommendationId: null,
      };
    },

    computed: {
      item() {
        return this.recommendations.find(
          recommendation => this.recommendationId === recommendation.id
        );
      },

      list() {
        return this.recommendations.filter(
          recommendation => this.recommendationId === recommendation.parent
        );
      },

      recommendations() {
        const recommendations = this.$store.state.recommendations.map(
          ({id, parent, title, text, image, contents, sort, published}) => {
            contents = contents.map(({id, title, text, image, sort}) => {
              return {id, title, text, image, sort,};
            });

            contents.sort((a, b) => a.sort - b.sort);

            return {id, parent, title, text, image, contents, sort, published};
          }
        );

        recommendations.sort((a, b) => a.sort - b.sort);

        return recommendations.filter(recommendation => {
          if (this.hasEarlyAccess) {
            return true;
          }

          return recommendation.published;
        });
      },

      hasEarlyAccess() {
        return this.$store.getters.hasEarlyAccess;
      },
    },

    methods: {
      selectRecommendation(id) {
        this.recommendationId = id;
      },
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page.page-recommendation {
    padding-top: 50px;

    .page-title {
      position: relative;
      margin: 0;
      padding: 20px 20px;
      text-align: left;

      i {
        position: absolute;
        top: 20px;
        right: 15px;
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: $primary;
      }
    }
  }
</style>
